import { createFileRoute } from '@tanstack/react-router'

import { FEATURE_LEARNPATH_EMBEDDED_VIDEO } from '@/core/constants/features'
import useFeatures from '@/core/utils/features/useFeatures'
import { LearnpathsAddElementsEmbeddedVideo } from '@/learnpaths/components/LearnpathsAddElementsEmbeddedVideo/LearnpathsAddElementsEmbeddedVideo'

export const Route = createFileRoute(
  '/company/learnpaths/add/elements/$learnpathId/(embedded-video)/update/embedded-video/$elementId',
)({
  component: RouteComponent,
})

function RouteComponent() {
  const hasLearnpathEmbeddedVideoFeature = useFeatures(
    FEATURE_LEARNPATH_EMBEDDED_VIDEO,
  )
  const params = Route.useParams()

  if (!hasLearnpathEmbeddedVideoFeature) {
    return null
  }

  return <LearnpathsAddElementsEmbeddedVideo mode="update" {...params} />
}
